import dayjs from 'dayjs';
import { Formik, FormikHelpers } from 'formik';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCreateCampaign } from '../../../../service/hooks';
import { MLS_SOURCE } from '../../../../utils/constants';
import CampaignForm from '../forms/CampaignForm';
import { CAMPAIGN_FORM_VALUES, CAMPAIGN_SCHEMA } from '../forms/schema';

const FORM_INIT: CAMPAIGN_FORM_VALUES = {
  type: '',
  typeActions: [],
  name: '',
  mlsSource: MLS_SOURCE.V2,
  stateOrProvince: '',
  city: '',
  standardStatus: '',
  radiusInMiles: 0,
  repeatDaysOfWeek: undefined,
  hourOfDay: 0,
  notes: undefined,
  listingContractDateFrom: undefined,
  listingContractDateTo: undefined,
  listingContractDateGreaterThanDays: undefined,
  listingContractDateLessThanDays: undefined,
  listPriceFrom: undefined,
  listPriceTo: undefined,
  yearBuiltFrom: undefined,
  yearBuiltTo: undefined,
  subdivisionName: undefined,
  listOfficeName: undefined,
  loanOfficerIds: [],
  listAgentEmailOmitIfNotExists: true,
  daysBetweenEmails: undefined,
  chimeTags: [],
};

const NewCampaign: FC = () => {
  const navigate = useNavigate();
  const { mutate: createCampaign } = useCreateCampaign();

  const onSubmit = (
    values: CAMPAIGN_FORM_VALUES,
    { setSubmitting, resetForm }: FormikHelpers<CAMPAIGN_FORM_VALUES>,
  ) => {
    const {
      listingContractDateFrom,
      listingContractDateTo,
      listingContractDateGreaterThanDays,
      listingContractDateLessThanDays,
      city,
      stateOrProvince,
      listPriceFrom,
      listPriceTo,
      yearBuiltFrom,
      yearBuiltTo,
      radiusInMiles,
      subdivisionName,
      listOfficeName,
      newConstructionYN,
      ownership,
      seniorCommunityYN,
      standardPropertyTypes,
      pendingTimestampTo,
      pendingTimestampFrom,
      offMarketTimestampTo,
      offMarketTimestampFrom,
      standardStatus,
      mlsSource,
      ...rest
    } = values;

    const payload = {
      campaignSearchQuery: {
        mlsSource,
        listingContractDateFrom: listingContractDateFrom ? dayjs(listingContractDateFrom).toISOString() : undefined,
        listingContractDateTo: listingContractDateTo ? dayjs(listingContractDateTo).toISOString() : undefined,
        listingContractDateGreaterThanDays,
        listingContractDateLessThanDays,
        city,
        stateOrProvince,
        listPriceFrom,
        listPriceTo,
        yearBuiltFrom,
        yearBuiltTo,
        radiusInMiles,
        subdivisionName,
        listOfficeName,
        newConstructionYN,
        ownership,
        seniorCommunityYN,
        standardPropertyTypes,
        pendingTimestampTo,
        pendingTimestampFrom,
        offMarketTimestampTo,
        offMarketTimestampFrom,
        standardStatus,
      },
      ...rest,
    };

    createCampaign(payload, {
      onSuccess: () => {
        resetForm();
        navigate('/');
      },
      onSettled: () => {
        setSubmitting(false);
      },
    });
  };

  return (
    <div className="mt-16">
      <Formik initialValues={FORM_INIT} onSubmit={onSubmit} validationSchema={CAMPAIGN_SCHEMA}>
        {() => <CampaignForm />}
      </Formik>
    </div>
  );
};

export default NewCampaign;
